import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import transpet from '@/views/transpet.vue'
import radsys from '@/views/radsys.vue'
import radsys2 from '@/views/radsys2.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/happening',
    name: 'happening',
    component: () => import('@/views/happening.vue')
  },
  {
    path: '/happening/:documentId',
    name: 'happening-detail',
    component: () => import('@/views/happening-detail.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: HomeView
  },
  {
    path: "*",
    redirect: '/home'
  },
  {
    path: '/trans-pet',
    name: 'transpet',
    component: transpet
  },
  {
    path: '/radsys',
    name: 'radsys',
    component: radsys
  },
  {
    path: '/radsys2',
    name: 'radsys2',
    component: radsys2
  },
  {
    path: '/radtrarge',
    name: 'radtrarge',
    component: () => import('@/views/radtrarge.vue')
  },
  {
    path: '/RadWall-Mu',
    name: 'RadWallMu',
    component: () => import('@/views/RadWall-Mu.vue')
  },
  {
    path: '/RadPavise',
    name: 'RadPavise',
    component: () => import('@/views/RadPavise.vue')
  },
  {
    path: '/RadWall',
    name: 'RadWall',
    component: () => import('@/views/RadWall.vue')
  },
  {
    path: '/RadHFC',
    name: 'RadHFC',
    component: () => import('@/views/RadHFC.vue')
  },
  {
    path: '/RadTarge-Mini',
    name: 'RadTargeMini',
    component: () => import('@/views/RadTarge-Mini.vue')
  },
  {
    path: '/ip',
    name: 'ip',
    component: () => import('@/views/ip.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/about.vue')
  },
  {
    path: '/Plug-n-Image',
    name: 'PlugNImage',
    component: () => import('@/views/Plug-n-Image.vue')
  },
  {
    path: '/particle',
    name: 'particle',
    component: () => import('@/views/particle.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果有保存的位置（浏览器前进/后退），则返回保存的位置
    if (savedPosition) {
      return savedPosition;
    } else {
      // 否则滚动到顶部
      return { x: 0, y: 0 };
    }
  }
})

// Keep the current page visible until the particle hero can be painted.
let particleHeroReady
function prepareParticleHero() {
  if (!particleHeroReady) {
    particleHeroReady = new Promise(resolve => {
      const image = new Image()
      let settled = false
      const finish = () => { if (!settled) { settled = true; clearTimeout(timer); resolve() } }
      const timer = setTimeout(finish, 5000)
      image.onload = () => { if (image.decode) image.decode().then(finish, finish); else finish() }
      image.onerror = () => { particleHeroReady = null; finish() }
      image.src = '/product-assets/e3eed6c3998978cd.png'
    })
  }
  return particleHeroReady
}
router.beforeResolve(async (to, from, next) => {
  if (to.path === '/particle') await prepareParticleHero()
  next()
})

export default router